import React from 'react';
import {
  get, filter,
} from 'lodash';
import isUndefined from 'lodash/isUndefined';
import {
  Button,
  TextField,
  Grid,
  InputLabel,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Select,
  ListItemText,
  MenuItem,
  IconButton,
  Tooltip,
} from '@mui/material';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CameraIcon from '@mui/icons-material/PhotoCamera';

import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

import { uploadUserImage, convertImageUrlToPublicId } from '../../lib/cloudinary';
import { BrandSelect } from '../common/brand-select';
import ProfilePhoto from '../common/profile-photo';
import AppCenterInfo from '../common/app-center-info';
import ErrorMessage from '../common/error-message';
import AppCenterButtons from '../common/app-center-buttons';
import {
  stateAbbreviations, WranglerRoleNames, wranglerStatuses,
  WranglerStatuses, IOS,
  LARGE_PROFILE_PHOTO_SIZE,
} from '../../lib/utils';
import {
  getWranglerRoleNamesForUser,
  ACTIONS,
  FEATURES,
} from '../../access';
import * as snackbarActions from '../../actions/snackbar';
import wranglerActions from '../../actions/wranglers';
import { MarketMultiSelect } from '../common/market-multi-select';

const styles = {
  phoneInput: {
    maxWidth: '100%',
  },
};

class UserEditForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      wrangler: props.wrangler,
      error: false,
    };

    this.handleSave = this.handleSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangePhone = this.handleChangePhone.bind(this);
    this.handleMarketIdsChange = this.handleMarketIdsChange.bind(this);
    this.handleBrandChange = this.handleBrandChange.bind(this);
    this.handleCameraClick = this.handleCameraClick.bind(this);
  }

  get assignedMarketsWithNames() {
    const assignedMarkets = get(this, 'state.wrangler.marketIds', []);
    const allMarkets = get(this, 'props.markets', []);
    return filter(allMarkets, (market) => assignedMarkets.includes(market._id));
  }

  get markets() {
    return get(this, 'props.markets', []);
  }

  handleMarketIdsChange(marketIds) {
    const { wrangler } = this.state;

    const newWrangler = {
      ...wrangler,
      marketIds,
    };

    this.setState({ wrangler: newWrangler });
  }

  handleBrandChange(brandName) {
    const { wrangler } = this.state;
    const newWrangler = { ...wrangler };

    if (brandName.length > 0) {
      newWrangler.brand = brandName;
    } else {
      newWrangler.brand = undefined;
    }

    this.setState({ wrangler: newWrangler });
  }

  handleCameraClick(event) {
    const { showErrorSnackbar } = this.props;
    const { wrangler } = this.state;
    uploadUserImage(event, wrangler._id)
      .then((data) => {
        const {
          secure_url: url,
          public_id: publicId,
        } = data;
        const newWrangler = {
          ...wrangler,
          profilePhoto: {
            url,
            publicId,
          },
        };
        this.setState({ wrangler: newWrangler });
      })
      .catch((e) => {
        showErrorSnackbar('Error uploading image', e);
      });
  }

  handleChange(event) {
    const { wrangler } = this.state;
    const { name, value } = event.target;

    const newWrangler = {
      ...wrangler,
      [name]: value,
    };

    this.setState({ wrangler: newWrangler });
  }

  handleChangePhone(phoneNumber) {
    const { wrangler } = this.state;
    const newWrangler = {
      ...wrangler,
      phoneNumber,
    };

    this.setState({ wrangler: newWrangler });
  }

  handleSave() {
    const { wrangler } = this.state;
    const { editing, onSave } = this.props;

    if (!wrangler.firstName) {
      return this.setState({ error: true, errorMessage: 'Please enter a first name.' });
    }
    if (!wrangler.lastName) {
      return this.setState({ error: true, errorMessage: 'Please enter a last name.' });
    }
    if (!wrangler.phoneNumber) {
      return this.setState({ error: true, errorMessage: 'Please enter a phone number.' });
    }
    if (!wrangler.role) {
      return this.setState({ error: true, errorMessage: 'Please select a role.' });
    }

    onSave(wrangler, editing);
  }

  render() {
    const {
      currentWrangler,
      isOpen,
      onCancel,
      wrangler: propsWrangler,
      onAppCenterClick,
    } = this.props;
    const {
      error, wrangler, errorMessage,
    } = this.state;
    const { email, appCenter, profilePhoto = {} } = wrangler;
    const { url } = profilePhoto;
    const wranglerRoleNames = getWranglerRoleNamesForUser(currentWrangler);

    let hasAccess;
    if (isUndefined(currentWrangler)) {
      hasAccess = () => false;
    } else {
      hasAccess = get(currentWrangler, 'access.can');
    }
    const isActive = wrangler.status === WranglerStatuses.ACTIVE;
    const sameEmail = email && wrangler.email === propsWrangler.email;

    const canShowAppInvites = isActive
      && hasAccess(ACTIONS.READ, FEATURES.APP_CENTER_BUTTONS)
      && sameEmail;

    const hasIOS = get(appCenter, 'ios.active');
    return (
      <Dialog
        open={isOpen}
        fullWidth
        maxWidth="lg"
        aria-labelledby="form-dialog-title"
        onClose={onCancel}
      >
        <DialogTitle id="form-dialog-title">
          <Grid container justifyContent="space-between">
            <Grid>
              Field Worker
            </Grid>
            <Grid>
              {canShowAppInvites && (
                <AppCenterButtons
                  emails={[email]}
                  showIOSAdd={!hasIOS}
                  showIOSEdit={hasIOS}
                  onClick={onAppCenterClick}
                />
              )}
            </Grid>
          </Grid>
          {error
          && (
            <ErrorMessage
              errorMessage={errorMessage}
            />
          )}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item md={3}>
              <InputLabel>
                First Name
              </InputLabel>
              <TextField
                autoFocus
                margin="dense"
                name="firstName"
                type="text"
                variant="standard"
                value={wrangler.firstName}
                fullWidth
                onChange={this.handleChange}
              />
            </Grid>
            <Grid item md={3}>
              <InputLabel>
                Last Name
              </InputLabel>
              <TextField
                margin="dense"
                name="lastName"
                type="text"
                variant="standard"
                value={wrangler.lastName}
                fullWidth
                onChange={this.handleChange}
              />
            </Grid>
            <Grid item md={6}>
              <InputLabel>
                Add Permissions to Market:
              </InputLabel>
              <MarketMultiSelect
                handleChange={this.handleMarketIdsChange}
                value={wrangler.marketIds}
              />
            </Grid>
            <Grid item md={3}>
              <InputLabel sx={{ mb: 1 }}>
                Phone Number
              </InputLabel>
              <PhoneInput
                country="us"
                regions={['america', 'europe']}
                value={wrangler.phoneNumber}
                inputStyle={styles.phoneInput}
                onChange={(phone) => this.handleChangePhone(phone)}
              />
            </Grid>
            <Grid item md={3}>
              <InputLabel>
                Email
              </InputLabel>
              <TextField
                margin="dense"
                name="email"
                type="email"
                variant="standard"
                value={wrangler.email}
                fullWidth
                onChange={this.handleChange}
              />
            </Grid>
            <Grid item md={3}>
              <InputLabel>
                Role
              </InputLabel>
              <Select
                onChange={this.handleChange}
                value={wrangler.role || ''}
                name="role"
                variant="standard"
                fullWidth
              >
                {wranglerRoleNames.map((role) => (
                  <MenuItem dense key={role} value={role}>
                    <ListItemText primary={role} />
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item md={3}>
              <InputLabel>
                Status
              </InputLabel>
              <Select
                onChange={this.handleChange}
                value={wrangler.status}
                name="status"
                variant="standard"
                fullWidth
              >
                {wranglerStatuses.map((status) => (
                  <MenuItem dense key={status} value={status}>
                    <ListItemText primary={status} />
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item md={6}>
              <InputLabel>
                Address
              </InputLabel>
              <TextField
                margin="dense"
                name="address"
                type="text"
                variant="standard"
                value={wrangler.address}
                fullWidth
                onChange={this.handleChange}
              />
              <InputLabel>
                City
              </InputLabel>
              <TextField
                margin="dense"
                name="city"
                type="text"
                variant="standard"
                value={wrangler.city}
                fullWidth
                onChange={this.handleChange}
              />
              <Grid container spacing={2}>
                <Grid item md={6}>
                  <InputLabel>
                    State
                  </InputLabel>
                  <Select
                    onChange={this.handleChange}
                    value={wrangler.state || ''}
                    name="state"
                    variant="standard"
                    fullWidth
                  >
                    {stateAbbreviations().map((state) => (
                      <MenuItem dense key={state} value={state}>
                        <ListItemText primary={state} />
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item md={6}>
                  <InputLabel>
                    Zipcode
                  </InputLabel>
                  <TextField
                    margin="dense"
                    name="zip"
                    type="text"
                    variant="standard"
                    value={wrangler.zip}
                    fullWidth
                    onChange={this.handleChange}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={3}>
              {get(wrangler, 'appCenter.ios') && (
                <AppCenterInfo
                  appCenter={wrangler.appCenter.ios}
                  version={IOS}
                />
              )}
            </Grid>
            <Grid item md={3}>
              {url && (
                <ProfilePhoto
                  publicId={convertImageUrlToPublicId(url)}
                  size={LARGE_PROFILE_PHOTO_SIZE}
                />
              )}
              <Tooltip title="Take Profile Picture">
                <IconButton onClick={this.handleCameraClick}>
                  <CameraIcon />
                </IconButton>
              </Tooltip>
            </Grid>
            <Grid item md={3}>
              {wrangler.role === WranglerRoleNames.BRAND_PARTNER && (
                <BrandSelect
                  value={wrangler.brand}
                  handleChange={this.handleBrandChange}
                  returnBrandKey={false}
                />
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancel} color="secondary">
            Cancel
          </Button>
          <Button onClick={this.handleSave} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...wranglerActions,
  ...snackbarActions,
}, dispatch);

const mapStateToProps = ({ markets, wranglers }) => ({
  markets: markets.markets,
  currentWrangler: wranglers.currentWrangler,
});

export const BaseUserEditForm = UserEditForm;
export default connect(mapStateToProps, mapDispatchToProps)(UserEditForm);
